export default __webpack_public_path__ + "static/media/firefly_logo_dark-grey.24fc3825.png";